<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.24902 11.332C7.58345 11.3322 8.66486 12.4146 8.66504 13.749V16.249C8.66486 17.5835 7.58345 18.6649 6.24902 18.665H3.74902C2.4146 18.6649 1.33221 17.5835 1.33203 16.249V13.749C1.33221 12.4146 2.4146 11.3322 3.74902 11.332H6.24902ZM3.74902 12.832C3.24303 12.8322 2.83221 13.243 2.83203 13.749V16.249C2.83221 16.755 3.24302 17.1649 3.74902 17.165H6.24902C6.75503 17.1649 7.16486 16.755 7.16504 16.249V13.749C7.16486 13.243 6.75502 12.8322 6.24902 12.832H3.74902Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.249 11.332C17.5835 11.3322 18.6649 12.4146 18.665 13.749V16.249C18.6649 17.5835 17.5835 18.6649 16.249 18.665H13.749C12.4146 18.6649 11.3322 17.5835 11.332 16.249V13.749C11.3322 12.4146 12.4146 11.3322 13.749 11.332H16.249ZM13.749 12.832C13.243 12.8322 12.8322 13.243 12.832 13.749V16.249C12.8322 16.755 13.243 17.1649 13.749 17.165H16.249C16.755 17.1649 17.1649 16.755 17.165 16.249V13.749C17.1649 13.243 16.755 12.8322 16.249 12.832H13.749Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.24902 1.33203C7.58345 1.33221 8.66486 2.4146 8.66504 3.74902V6.24902C8.66486 7.58345 7.58345 8.66486 6.24902 8.66504H3.74902C2.4146 8.66486 1.33221 7.58345 1.33203 6.24902V3.74902C1.33221 2.4146 2.4146 1.33221 3.74902 1.33203H6.24902ZM3.74902 2.83203C3.24303 2.83221 2.83221 3.24303 2.83203 3.74902V6.24902C2.83221 6.75502 3.24302 7.16486 3.74902 7.16504H6.24902C6.75503 7.16486 7.16486 6.75503 7.16504 6.24902V3.74902C7.16486 3.24302 6.75502 2.83221 6.24902 2.83203H3.74902Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.249 1.33203C17.5835 1.33221 18.6649 2.4146 18.665 3.74902V6.24902C18.6649 7.58345 17.5835 8.66486 16.249 8.66504H13.749C12.4146 8.66486 11.3322 7.58345 11.332 6.24902V3.74902C11.3322 2.4146 12.4146 1.33221 13.749 1.33203H16.249ZM13.749 2.83203C13.243 2.83221 12.8322 3.24303 12.832 3.74902V6.24902C12.8322 6.75502 13.243 7.16486 13.749 7.16504H16.249C16.755 7.16486 17.1649 6.75503 17.165 6.24902V3.74902C17.1649 3.24302 16.755 2.83221 16.249 2.83203H13.749Z"
            fill="currentColor"
        />
    </svg>
</template>
